package org.hs_soft.runmynesto.domain.model.home.home.user_profile_info


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GetUserProfileData(
    @SerialName("company")
    val company: Company?,
    @SerialName("sub")
    val sub: String?,
    @SerialName("user")
    val user: User?
)